<template>
  <div>
    <v-dialog v-model="olahDataDialog" persistent max-width="600">
      <v-card>
        <v-card-title class="text-h6 font-weight-bold">
          {{ olahDataTitle }}
        </v-card-title>

        <v-divider class="mx-5"></v-divider>

        <v-card-text class="pb-0 mt-3">
          <v-form ref="form" v-model="valid">
            <v-card-title
              class="pa-0 text-subtitle-1 font-weight-bold black--text"
            >
              Android ID
            </v-card-title>
            <v-text-field
              v-model="olahData.mac_address"
              outlined
              dense
              :rules="[rules.required]"
              autocomplete="off"
            ></v-text-field>

            <v-card-title
              class="pa-0 text-subtitle-1 font-weight-bold black--text"
            >
              Device ID
            </v-card-title>
            <v-text-field
              v-model="olahData.kode"
              outlined
              dense
              :rules="[rules.required]"
              autocomplete="off"
            ></v-text-field>

            <v-card-title
              class="pa-0 text-subtitle-1 font-weight-bold black--text"
            >
              Gudang
            </v-card-title>
            <v-select
              v-model="olahData.gudang_id"
              dense
              outlined
              :items="dataGudang"
              item-text="name"
              item-value="id"
              :rules="[rules.required]"
            >
            </v-select>

            <v-card-title
              class="pa-0 text-subtitle-1 font-weight-bold black--text"
            >
              Keterangan
            </v-card-title>
            <v-text-field
              v-model="olahData.desc"
              outlined
              dense
              :rules="[rules.required]"
              autocomplete="off"
            ></v-text-field>

            <v-card-title
              class="pa-0 text-subtitle-1 font-weight-bold black--text"
            >
              Latitude
            </v-card-title>
            <v-text-field
              v-model="olahData.lat"
              type="number"
              outlined
              dense
              :rules="[rules.required]"
              autocomplete="off"
            ></v-text-field>

            <v-card-title
              class="pa-0 text-subtitle-1 font-weight-bold black--text"
            >
              Longitude
            </v-card-title>
            <v-text-field
              v-model="olahData.long"
              type="number"
              outlined
              dense
              :rules="[rules.required]"
              autocomplete="off"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions class="pt-0 pb-5">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="#61B15A"
            style="text-transform: unset !important"
            @click="closeOlahData"
          >
            Batal
          </v-btn>
          <v-btn
            color="#61B15A"
            class="white--text"
            style="text-transform: unset !important"
            @click="checkType"
            :disabled="!valid"
            :loading="loading"
          >
            {{ olahDataBtn }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="popDialog" width="500">
      <v-card color="white" rounded>
        <v-card-title class="justify-center text-h6 black--text">
          {{ popTitle }}
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="light-green darken-1"
            class="white--text"
            @click="closePopDialog"
            >Tutup</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    olahDataDialog: Boolean,
    olahDataTitle: String,
    olahDataBtn: String,
    olahData: Object,
    typeAction: String,
    dataGudang: Array,
  },
  data: () => ({
    valid: false,
    loading: false,
    rules: {
      required: (value) => !!value || "Tidak boleh kosong !!",
    },
    popDialog: false,
    popTitle: "",
  }),
  methods: {
    checkType() {
      this.loading = true;
      if (this.typeAction === "edit") {
        this.edit();
      } else if (this.typeAction === "new") {
        this.new();
      }
    },
    new() {
      const data = JSON.stringify(this.olahData);
      axios
        .post("v1/admin/device", data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(() => {
          this.loading = false;
          this.$emit("reloadData");
          this.closeOlahData();
        })
        .catch((error) => {
          if (error.response) {
            this.loading = false;
            this.popTitle = "Data gagal ditambahkan. Periksa kembali inputan anda.";
            this.popDialog = true;
          }
        });
    },
    edit() {
      const data = JSON.stringify(this.olahData);
      axios
        .put("v1/admin/device", data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.status === 201) {
            this.loading = false;
            this.$emit("reloadData");
            this.closeOlahData();
          }
        })
        .catch((error) => {
          if (error.response) {
            this.loading = false;
            console(error.response);
          }
        });
    },
    closeOlahData() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.$emit("closeOlahDataDialog");
    },
    closePopDialog() {
      this.popTitle = "";
      this.popDialog = false;
    },
  },
};
</script>